export default __webpack_public_path__ + "static/cello-6cc36d989ea53b73b2ff6e4d655e9726.jpeg";